import { FormField } from 'components/form';
import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';
import StatusLabel from 'components/status-label/StatusLabel';
import { capitalize } from 'lodash';
import React from 'react';
import { __t } from 'utils/language';
import { isFalsy } from 'utils/validators';
import { useTags } from './helpers';

export function EntertainmentVideoTags({
  tags: currentTags,
  isEditMode = false,
  onTagsChange
}: {
  tags: Array<string>,
  isEditMode?: boolean,
  onTagsChange?: (tags: Array<string>) => void
}) {
  const tags = useTags();

  if (isEditMode) {
    const options = tags.map((tag) => ({
      label: capitalize(tag.title),
      value: tag.id,
      identifier: tag.id,
      isDisabled: false,
      isFocused: false,
      isSelected: currentTags.includes(tag.id)
    }));

    return (
      <FormField
        showValidationIcon={false}
        labelType="highlighted"
        direction="column"
        fontSize="small"
        validators={[
          isFalsy(
            currentTags.length === 0,
            __t('realm_outfit_details_edit.errors.no_gtl_tags')
          )
        ]}
      >
        <MixedSelectDropdown
          withRemovable
          withMulti
          name="tags"
          className="realm-outfit-details-edit__compact-select"
          items={options}
          onItemsToggle={(_, __, addedItem) => {
            if (addedItem?.value) {
              onTagsChange?.([...currentTags, addedItem.value]);
            }
          }}
          onItemsRemove={(_, __, removedItem) => {
            if (removedItem?.value) {
              onTagsChange?.(
                currentTags.filter((t) => t !== removedItem.value)
              );
            }
          }}
          onItemsRemoveAll={() => {
            onTagsChange?.([]);
          }}
        />
      </FormField>
    );
  }

  if (currentTags.length === 0) {
    return <span>–</span>;
  }

  const tagIdToTitleMap = tags.reduce((map, tag) => {
    map.set(tag.id, tag.title);
    return map;
  }, new Map<string, string>());

  return (
    <div style={{ display: 'flex', gap: '6px', flexFlow: 'row wrap' }}>
      {currentTags.map((tag) => {
        const title = tagIdToTitleMap.get(tag);

        if (title) {
          return (
            <StatusLabel
              key={tag}
              label={capitalize(title)}
              type="neutral"
              size="small"
            />
          );
        }

        return null;
      })}
    </div>
  );
}
